import type { HTMLAttributes } from "react";

import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

export type TArticleProps = TWithDataComponent & HTMLAttributes<HTMLElement>;

type TArticleDefaultProps = DefinedDefaults<
  TArticleProps,
  "data-component"
>;

export const ARTICLE_DEFAULTS = {
  "data-component": "Article",
} satisfies TArticleDefaultProps;
